export const ADD_CHITTIES_STARTED = 'ADD_CHITTIES_STARTED';
export const ADD_CHITTIES_COMPLETED = 'ADD_CHITTIES_COMPLETED';
export const ADD_CHITTIES_ERROR = 'ADD_CHITTIES_ERROR';

export const FETCH_CHITTIES_STARTED = 'FETCH_CHITTIES_STARTED';
export const FETCH_CHITTIES_COMPLETED = 'FETCH_CHITTIES_COMPLETED';
export const FETCH_CHITTIES_ERROR = 'FETCH_CHITTIES_ERROR';

export const CLEAR_CHITTIES = 'CLEAR_CHITTIES';

export const EDIT_CHITTY_STARTED = 'EDIT_CHITTY_STARTED';
export const EDIT_CHITTY_COMPLETED = 'EDIT_CHITTY_COMPLETED';
export const EDIT_CHITTY_ERROR = 'EDIT_CHITTY_ERROR';

export const ADD_CHITTIEUSERS_STARTED = 'ADD_CHITTIEUSERS_STARTED';
export const ADD_CHITTIEUSERS_COMPLETED = 'ADD_CHITTIEUSERS_COMPLETED';
export const ADD_CHITTIEUSERS_ERROR = 'ADD_CHITTIEUSERS_ERROR';

export const REPLACE_CHITTYUSER_STARTED = 'REPLACE_CHITTYUSER_STARTED';
export const REPLACE_CHITTYUSER_COMPLETED = 'REPLACE_CHITTYUSER_COMPLETED';
export const REPLACE_CHITTYUSER_ERROR = 'REPLACE_CHITTYUSER_ERROR';

export const SORT_CHITTIES_STARTED = 'SORT_CHITTIES_STARTED';
export const SORT_CHITTIES_COMPLETED = 'SORT_CHITTIES_COMPLETED';
export const SORT_CHITTIES_ERROR = 'SORT_CHITTIES_ERROR';

export const CLOSE_CHITTY_STARTED = 'CLOSE_CHITTY_STARTED';
export const CLOSE_CHITTY_COMPLETED = 'CLOSE_CHITTY_COMPLETED';
export const CLOSE_CHITTY_ERROR = 'CLOSE_CHITTY_ERROR';

export const FETCH_ALL_CHITTIES_STARTED = 'FETCH_ALL_CHITTIES_STARTED';
export const FETCH_ALL_CHITTIES_COMPLETED = 'FETCH_ALL_CHITTIES_COMPLETED';
export const FETCH_ALL_CHITTIES_ERROR = 'FETCH_ALL_CHITTIES_ERROR';

export const FETCH_COMPLETED_CHITTIES_STARTED = 'FETCH_COMPLETED_CHITTIES_STARTED';
export const FETCH_COMPLETED_CHITTIES_COMPLETED = 'FETCH_COMPLETED_CHITTIES_COMPLETED';
export const FETCH_COMPLETED_CHITTIES_ERROR = 'FETCH_COMPLETED_CHITTIES_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/chittiesActionTypes.js